<script>
	import { onMount } from "svelte";
	import { getPosts } from "./getPosts.js";
	import { store } from "./store.js";
	import Toolbar from "./components/Toolbar.svelte";
	import PostGrid from "./components/PostGrid.svelte";
	import PostList from "./components/PostList.svelte";
	import PostMap from "./components/PostMap.svelte";
	import Pagination from "./components/Pagination.svelte";
	import Search from "./components/Search.svelte";
	let postsData,
		search = false;

	$store.options[$$props.id] = {
		loading: true,
		filtres: {
			mode: $$props.filtresParDefaut.mode,
			mode: $$props.filtresParDefaut.deux_colonnes
		}
	};
	$store.posts[$$props.id] = {};
	$store.groupedPosts[$$props.id] = {};

	let id = $$props.id;

	onMount(async () => {
		$store.options[$$props.id] = $$props;

		let params = new URLSearchParams(
			$store.options[$$props.id].filtresParDefaut
		).toString();
		let myPosts = await getPosts(params);
		$store.posts[$$props.id] = myPosts;
		$store.options[$$props.id].found_posts = myPosts.found_posts;
		$store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
		$store.options[$$props.id].loading = false;

		search = $store.options[$$props.id].filtres.search
			? $store.options[$$props.id].filtres.search
			: false;
	});
</script>

{#if $$props.debug}
	<h4>Debug</h4>
	<code>
		Store :
		{JSON.stringify($store)}
	</code>
	<code>
		Props :
		{JSON.stringify($$props)}
	</code>
{/if}

{#if search}
	<Search id={$$props.id} />
{/if}

{#if $$props.masquer_barre_outils != 1}
	<Toolbar
		id={$$props.id}
		masquer_mode_liste={$$props.masquer_mode_liste}
		type_contenus={$$props.filtresParDefaut.type_contenus}
	/>
{/if}
{#if $store.options[$$props.id].filtres && $store.options[$$props.id].filtres.mode == "grid"}
	<PostGrid id={$$props.id} />
{/if}
{#if $store.options[$$props.id].filtres && $store.options[$$props.id].filtres.mode == "list"}
	<PostList id={$$props.id} />
{/if}
{#if $store.options[$$props.id].filtres && $store.options[$$props.id].filtres.mode == "map"}
	<PostMap id={$$props.id} />
{/if}
{#if !$store.options[$$props.id].masquer_pagination && $store.posts[$$props.id].cg_posts && $store.options[$$props.id].max_num_pages > 1}
	<Pagination id={$$props.id} />
{/if}
<!-- 

{JSON.stringify($posts)} -->
